// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `a {
  display: inline-block;
  text-decoration: none;
  text-decoration-skip-ink: auto;
  color: inherit;
  position: relative;
  transition: all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);
}

a:hover{
  color: #af8559;
}

header {
  height: 80px;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  font-size: 20px;
  position: fixed;
  z-index: 5;
  background-color: #695036;
}

#logo1 {
  width: 250px;
  animation: slide-in-left 1s cubic-bezier(0.250, 0.460, 0.450, 0.940) forwards;
}

.header-list {
  display: flex;
  flex-direction: row;
}

.header-item {
  opacity: 0;
  list-style: none;
  padding: .5rem 1rem;
  animation: slide-in-top 1s forwards;
}

 .header-item:nth-child(1) {
  animation-delay: .2s;
}
 .header-item:nth-child(2) {
  animation-delay: .4s;
}
 .header-item:nth-child(3) {
  animation-delay: .6s;
}
 .header-item:nth-child(4) {
  animation-delay: .8s;
}
 .header-item:nth-child(5) {
  animation-delay: 1s;
}
 .header-item:nth-child(6) {
  animation-delay: 1.2s;
}

.btn-close {
  opacity: 0;
  position: fixed;
  margin-right: 5%;
  width: 40px;
  height: 40px;
  right: 0;
  border: none;
  top: 15px;
  background: #695036;
  text-align: center;
  border-radius: 5px;
  padding: 0;
  cursor: pointer;
}

.closed{
  display: none;
}
.opened {
  height: unset;
}

.btn-close img{
  filter: invert(100%) sepia(9%) saturate(1%) hue-rotate(226deg) brightness(104%) contrast(96%);
}

.btn-close:hover{
  border: none;
  background: rgb(75, 116, 159, .1);
}


@media (max-width: 830px)
{
  header {
    animation: slide-in-top 1.2s forwards;
    justify-content: flex-start;
    display: flex;
  }
  .btn-close {
    opacity: 1;
  }
  .logo {
    width: 40%;
  }
  #logo1 {
    width: 170px
  }
  .header-list {
    margin-top: 10px;
    flex-direction: column;
    width: 100%;
    align-items: center;
  }
}


@media (max-width: 360px)
{
  .logo {
    display: none;
  }
}

@media (min-width: 831px)
{
  .closed {
    display: flex;
  }
  .header-list {
    animation: slide-in-top .8s forwards;
  }
}

@keyframes slide-in-top {
  0% {
    transform: translateY(-1000px);
    opacity: 0;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
}

@keyframes slide-in-top {
  0% {
    transform: translateY(-1000px);
    opacity: 0;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Header/style.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,8BAA8B;EAC9B,cAAc;EACd,kBAAkB;EAClB,0DAA0D;AAC5D;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,6EAA6E;AAC/E;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,mBAAmB;EACnB,mCAAmC;AACrC;;CAEC;EACC,oBAAoB;AACtB;CACC;EACC,oBAAoB;AACtB;CACC;EACC,oBAAoB;AACtB;CACC;EACC,oBAAoB;AACtB;CACC;EACC,mBAAmB;AACrB;CACC;EACC,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,QAAQ;EACR,YAAY;EACZ,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;;AAEA;EACE,6FAA6F;AAC/F;;AAEA;EACE,YAAY;EACZ,iCAAiC;AACnC;;;AAGA;;EAEE;IACE,qCAAqC;IACrC,2BAA2B;IAC3B,aAAa;EACf;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE;EACF;EACA;IACE,gBAAgB;IAChB,sBAAsB;IACtB,WAAW;IACX,mBAAmB;EACrB;AACF;;;AAGA;;EAEE;IACE,aAAa;EACf;AACF;;AAEA;;EAEE;IACE,aAAa;EACf;EACA;IACE,oCAAoC;EACtC;AACF;;AAEA;EACE;IACE,8BAA8B;IAC9B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE;IACE,8BAA8B;IAC9B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF","sourcesContent":["a {\n  display: inline-block;\n  text-decoration: none;\n  text-decoration-skip-ink: auto;\n  color: inherit;\n  position: relative;\n  transition: all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);\n}\n\na:hover{\n  color: #af8559;\n}\n\nheader {\n  height: 80px;\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-around;\n  align-items: center;\n  font-size: 20px;\n  position: fixed;\n  z-index: 5;\n  background-color: #695036;\n}\n\n#logo1 {\n  width: 250px;\n  animation: slide-in-left 1s cubic-bezier(0.250, 0.460, 0.450, 0.940) forwards;\n}\n\n.header-list {\n  display: flex;\n  flex-direction: row;\n}\n\n.header-item {\n  opacity: 0;\n  list-style: none;\n  padding: .5rem 1rem;\n  animation: slide-in-top 1s forwards;\n}\n\n .header-item:nth-child(1) {\n  animation-delay: .2s;\n}\n .header-item:nth-child(2) {\n  animation-delay: .4s;\n}\n .header-item:nth-child(3) {\n  animation-delay: .6s;\n}\n .header-item:nth-child(4) {\n  animation-delay: .8s;\n}\n .header-item:nth-child(5) {\n  animation-delay: 1s;\n}\n .header-item:nth-child(6) {\n  animation-delay: 1.2s;\n}\n\n.btn-close {\n  opacity: 0;\n  position: fixed;\n  margin-right: 5%;\n  width: 40px;\n  height: 40px;\n  right: 0;\n  border: none;\n  top: 15px;\n  background: #695036;\n  text-align: center;\n  border-radius: 5px;\n  padding: 0;\n  cursor: pointer;\n}\n\n.closed{\n  display: none;\n}\n.opened {\n  height: unset;\n}\n\n.btn-close img{\n  filter: invert(100%) sepia(9%) saturate(1%) hue-rotate(226deg) brightness(104%) contrast(96%);\n}\n\n.btn-close:hover{\n  border: none;\n  background: rgb(75, 116, 159, .1);\n}\n\n\n@media (max-width: 830px)\n{\n  header {\n    animation: slide-in-top 1.2s forwards;\n    justify-content: flex-start;\n    display: flex;\n  }\n  .btn-close {\n    opacity: 1;\n  }\n  .logo {\n    width: 40%;\n  }\n  #logo1 {\n    width: 170px\n  }\n  .header-list {\n    margin-top: 10px;\n    flex-direction: column;\n    width: 100%;\n    align-items: center;\n  }\n}\n\n\n@media (max-width: 360px)\n{\n  .logo {\n    display: none;\n  }\n}\n\n@media (min-width: 831px)\n{\n  .closed {\n    display: flex;\n  }\n  .header-list {\n    animation: slide-in-top .8s forwards;\n  }\n}\n\n@keyframes slide-in-top {\n  0% {\n    transform: translateY(-1000px);\n    opacity: 0;\n  }\n  100% {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n\n@keyframes slide-in-top {\n  0% {\n    transform: translateY(-1000px);\n    opacity: 0;\n  }\n  100% {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
